import React, { useState, useEffect } from 'react';
import CardProducto from './CardProducto';
import axios from 'axios'; // Asegúrate de instalar axios: npm install axios
import clienteAxios from '../../helpers/axios.helper';

function ProductosDestacados() {
  const [productosDestacados, setProductosDestacados] = useState([]);
  const [error, setError] = useState(null); // Para manejar errores

  useEffect(() => {
    const fetchProductosDestacados = async () => {
      try {
        const response = await clienteAxios.get('/productos/destacados'); // Ajusta la ruta según tu backend
        setProductosDestacados(response.data);
      } catch (err) {
        setError('Error al cargar los productos destacados');
        console.error(err);
      }
    };

    fetchProductosDestacados();
  }, []);

  return (
    <div className='w-full h-3/12 flex items-center flex-wrap justify-evenly p-4'>
      {error && <p className="text-red-500">{error}</p>} {/* Mensaje de error */}
      {productosDestacados.length > 0 ? (
        productosDestacados.map(pd => <CardProducto key={pd.id} producto={pd} />)
      ) : (
        <p className="text-gray-500">No hay productos destacados disponibles.</p>
      )}
    </div>
  );
}

export default ProductosDestacados;
